var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.isLogged())?_c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[(_vm.loading)?_c('v-progress-linear',{staticClass:"mb-4",attrs:{"indeterminate":"","color":"book"}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }